import { Field } from "../../../types/TenantInterfaces";
import Library from "../../../views/library/Library";

interface Props {
  field: Field;
  recordID: string | undefined;
  moduleAPIName: string;
}

function ImageGallery({ field, moduleAPIName, recordID }: Props) {
  return (
    <Library
      type="Growth Drive Record"
      withHeader={false}
      recordID={recordID ?? ""}
      moduleAPIName={moduleAPIName}
      isPrivate={!field?.Public}
      fieldAPIName={field?.APIName}
    />
  );
}

export default ImageGallery;
